import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_CAMPAIGNS,
  CREATE_CAMPAIGN,
  UPDATE_CAMPAIGN,
  DELETE_CAMPAIGN,
} from "./actionTypes"
import {
  getAllCampaignsCall,
  createCampaignCall,
  updateCampaignCall,
  deleteCampaignCall,
  API_URL,
} from "../../helpers/repository"
import { getAllCampaigns, getAllCampaignsResponseSuccess } from "./actions"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"

function* attemptGetAllCampaigns() {
  try {
    const response = yield call(getAllCampaignsCall)
    yield put(getAllCampaignsResponseSuccess(response.data.data))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateCampaign(action) {
  const { history } = action
  try {
    const response = yield call(createCampaignCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/crm/content/campaigns")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditPromotion(action) {
  const { history, id } = action
  try {
    const response = yield call(updateCampaignCall, action.payload, id)
    showMessage("success", response.data.message)
    yield put(getAllCampaigns())
    history.push(`/crm/content/campaigns`)
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeletePromotion(action) {
  try {
    const response = yield call(deleteCampaignCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllCampaigns())
    history.push(`/crm/content/campaigns`)
  } catch (error) {
    showErrorMessages(error)
  }
}

function* CampaignsSaga() {
  yield takeEvery(GET_ALL_CAMPAIGNS, attemptGetAllCampaigns)
  yield takeEvery(CREATE_CAMPAIGN, attemptCreateCampaign)
  yield takeEvery(UPDATE_CAMPAIGN, attemptEditPromotion)
  yield takeEvery(DELETE_CAMPAIGN, attemptDeletePromotion)
}

export default CampaignsSaga
